// extracted by mini-css-extract-plugin
module.exports = {"timer_mobile":"recording_timer_mobile__1YHj9","timer_wrapper":"recording_timer_wrapper__rcETg","timer_text":"recording_timer_text__37vvQ"};